/* Soap Supply v2 - interaction layer (story, pinned gallery, cursor, progress, marquee velocity) */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(pointer: fine)').matches;
  var DESK = window.matchMedia('(min-width: 990px)');
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  var bar = null, stories = [], gals = [], anims = [], lastY = window.scrollY, vel = 0, rate = 1, ticking = false, loopRaf = null;

  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function headerH() { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')); return isNaN(v) ? 0 : v; }

  /* ---------- Sticky photo story ---------- */
  function initStories(root) {
    $$(root, '[data-sx-story]:not([data-sx-bound])').forEach(function (s) {
      s.setAttribute('data-sx-bound', '');
      var st = { el: s, steps: $$(s, '[data-sx-step]'), frames: $$(s, '[data-sx-frame]'), dots: $$(s, '[data-sx-dot]'), num: s.querySelector('[data-sx-num]'), active: -1 };
      stories.push(st);
      setStory(st, 0);
    });
  }
  function setStory(st, i) {
    if (st.active === i) return;
    st.active = i;
    st.steps.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
    st.frames.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
    st.dots.forEach(function (x, k) { x.classList.toggle('is-active', k <= i); });
    if (st.num) {
      var n = st.num;
      n.classList.add('is-swap');
      setTimeout(function () { n.textContent = ('0' + (i + 1)).slice(-2); n.classList.remove('is-swap'); }, 220);
    }
  }
  function updateStory(st) {
    if (!st.el.isConnected) return;
    var mid = window.innerHeight * 0.52, best = 0, bestD = Infinity;
    st.steps.forEach(function (x, k) {
      var r = x.getBoundingClientRect();
      var d = Math.abs(r.top + r.height / 2 - mid);
      if (d < bestD) { bestD = d; best = k; }
    });
    setStory(st, best);
  }

  /* ---------- Pinned horizontal gallery ---------- */
  function initGals(root) {
    $$(root, '[data-sx-hscroll]:not([data-sx-bound])').forEach(function (s) {
      s.setAttribute('data-sx-bound', '');
      var g = { el: s, pin: s.querySelector('.sx-gal__pin'), track: s.querySelector('.sx-gal__track'), bar: s.querySelector('.sx-gal__bar i'), dist: 0, pinH: 0 };
      if (!g.track) return;
      gals.push(g);
      if ('IntersectionObserver' in window) { var lio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { $(s, 'img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); lio.disconnect(); } }, { rootMargin: '900px 0px' }); lio.observe(s); }
      g.track.addEventListener('scroll', function () { if (!g.dist && g.bar) { var m = g.track.scrollWidth - g.track.clientWidth; g.bar.style.transform = 'scaleX(' + (m > 0 ? g.track.scrollLeft / m : 0).toFixed(3) + ')'; } }, { passive: true });
      measure(g);
    });
  }
  function measure(g) {
    if (RM || DESIGN || !DESK.matches) {
      g.el.removeAttribute('data-sx-hscroll-ready'); g.el.style.height = ''; g.track.style.transform = ''; g.dist = 0; return;
    }
    g.el.setAttribute('data-sx-hscroll-ready', '');
    g.track.style.transform = '';
    var dist = g.track.scrollWidth - document.documentElement.clientWidth;
    g.dist = Math.max(0, dist);
    g.pinH = g.pin ? g.pin.offsetHeight : window.innerHeight;
    g.el.style.height = (g.pinH + g.dist) + 'px';
    updateGal(g);
  }
  function updateGal(g) {
    if (!g.dist) return;
    var r = g.el.getBoundingClientRect();
    var total = r.height - g.pinH;
    var p = total > 0 ? clamp((headerH() - r.top) / total, 0, 1) : 0;
    g.track.style.transform = 'translate3d(' + (-p * g.dist).toFixed(1) + 'px,0,0)';
    if (g.bar) g.bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
  }

  /* ---------- Marquee reacts to scroll speed ---------- */
  function collectAnims() {
    if (!document.getAnimations) return;
    anims = document.getAnimations().filter(function (a) { return a.animationName === 'ss-marquee'; });
  }
  function loop() {
    loopRaf = null;
    var target = 1 + Math.min(5, Math.abs(vel) * 0.09);
    rate += (target - rate) * 0.12;
    vel *= 0.86;
    anims.forEach(function (a) { try { a.playbackRate = rate; } catch (e) {} });
    var sk = clamp(vel * -0.12, -6, 6);
    document.documentElement.style.setProperty('--sx-skew', sk.toFixed(2) + 'deg');
    if (Math.abs(rate - 1) > 0.01 || Math.abs(vel) > 0.1) loopRaf = requestAnimationFrame(loop);
    else { rate = 1; anims.forEach(function (a) { try { a.playbackRate = 1; } catch (e) {} }); document.documentElement.style.setProperty('--sx-skew', '0deg'); }
  }

  /* ---------- Scroll driver ---------- */
  function onScroll() {
    var y = window.scrollY;
    vel = vel * 0.5 + (y - lastY) * 0.5;
    lastY = y;
    if (!RM && anims.length && !loopRaf) loopRaf = requestAnimationFrame(loop);
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (bar) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? clamp(window.scrollY / max, 0, 1) : 0).toFixed(4) + ')';
      }
      stories.forEach(updateStory);
      gals.forEach(updateGal);
    });
  }

  /* ---------- Cursor bubble on photo cards ---------- */
  function cursor() {
    if (!FINE || RM || DESIGN) return;
    var c = document.createElement('div');
    c.className = 'sx-cursor'; c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<span></span>';
    document.body.appendChild(c);
    var lab = c.firstChild, x = 0, y = 0, cx = 0, cy = 0, raf = null, on = false;
    function move() {
      cx += (x - cx) * 0.2; cy += (y - cy) * 0.2;
      c.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      raf = (Math.abs(x - cx) > 0.3 || Math.abs(y - cy) > 0.3) ? requestAnimationFrame(move) : null;
    }
    document.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY;
      var t = e.target && e.target.closest ? e.target.closest('[data-sx-cursor]') : null;
      if (t) {
        if (!on) { on = true; cx = x; cy = y; c.classList.add('is-on'); }
        var l = t.getAttribute('data-sx-cursor') || 'View';
        if (lab.textContent !== l) lab.textContent = l;
      } else if (on) { on = false; c.classList.remove('is-on'); }
      if (!raf) raf = requestAnimationFrame(move);
    }, { passive: true });
    document.addEventListener('pointerleave', function () { on = false; c.classList.remove('is-on'); });
  }

  function init(root) {
    root = root || document;
    initStories(root);
    initGals(root);
    collectAnims();
    onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    bar = document.createElement('div');
    bar.className = 'sx-progress'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    init(document);
    cursor();
    setTimeout(function () { collectAnims(); gals.forEach(measure); }, 1200);
  });
  window.addEventListener('load', function () { gals.forEach(measure); onScroll(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  var rt = null;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { gals.forEach(measure); onScroll(); }, 150); });
  DESK.addEventListener && DESK.addEventListener('change', function () { gals.forEach(measure); });
  document.addEventListener('shopify:section:load', function (e) { gals = gals.filter(function (g) { return g.el.isConnected; }); stories = stories.filter(function (s) { return s.el.isConnected; }); init(e.target); });
})();
